import { FC, Fragment, ReactNode, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useBlur, useNotification } from '@/hooks'
import { CategoryState, ComponentState, SideoverState, TagState, UserState } from '@/states'
import { GoogleIcon } from '@/ui/icons'
import { AuthHandler, AuthInvoke } from '@/controllers/user'
import { USER_ROLES } from '@/data'

const Auth: FC = (): ReactNode => {
    useBlur()

    const { push, asPath, pathname } = useRouter()
    const { User, SetState, Loading, SmallLoading } = UserState()
    const { InitNotification } = useNotification()

    const { SetState: SideoverSetState } = SideoverState()
    const { SetState: CategorySetState } = CategoryState()
    const { SetState: TagSetState } = TagState()
    const { SetState: ComponentSetState } = ComponentState()

    AuthHandler(
        User,
        SetState,
        InitNotification
    )

    const StartAuthentication = () => AuthInvoke(
        User,
        Loading,
        SetState,
        InitNotification,
        push,
        SideoverSetState,
        CategorySetState,
        ComponentSetState,
        TagSetState
    )

    useEffect(() => {
        if (User && User !== null && !Loading && User?._id) {
            if (User?.Role !== USER_ROLES.ADMIN) {
                push('/500')
            }
        }
    }, [User, asPath, pathname])

    if (!User?._id) return (
        <Fragment>
            <div className='select-none fixed inset-0 bg-black/50 backdrop-blur-[3px] z-[100]'></div>

            <section className='select-none fixed w-full h-screen top-0 right-0 bottom-0 left-0 flex items-center justify-center z-[100] ignore-blur'>
                <div className='max-w-md w-full bg-[#262626] h-auto p-8 rounded-md border border-[#424242] ignore-blur'>
                    <h1 className='text-2xl font-bold tracking-tight text-[#EBEBEB] sm:text-4xl ignore-blur'>
                        Login to Modulo
                    </h1>

                    <p className='mt-2 text-[#CDD5DA] xl:text-md text-[14px] xl-[35%] ignore-blur'>
                        Where the magic happens for Modulo.
                    </p>

                    <button onClick={StartAuthentication} className='select-none button-gradient flex mt-8 items-center justify-center w-full px-4 py-2 text-sm font-medium text-[#EBEBEB] rounded-md md:w-auto hover:opacity-90 transition-all ease-in-out duration-500 ignore-blur'>
                        { !SmallLoading && <GoogleIcon /> }

                        {
                            SmallLoading &&
                            <svg className='w-[24px] h-[24px] text-[#EBEBEB] animate-spin fill-[#40404090] ignore-blur' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path className='ignore-blur' d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor'/>
                                <path className='ignore-blur' d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='currentFill'/>
                            </svg>
                        }

                        <span className='ml-2 ignore-blur'>
                            Sign in with Google
                        </span>
                    </button>
                </div>
            </section>
        </Fragment>
    )
}

export default Auth
